import { init, track } from '@plausible-analytics/tracker'

import { useConfig } from '@/composables/useConfig'
import { useCurUser } from '@/composables/useCurUser'
import { useRequest } from '@/composables/useRequest'

// Use a rollup to combine global and tenant-specific plausible metrics in separate sites
const hostname_parts = location.hostname.split('.')
let generic_hostname = null
if (hostname_parts[hostname_parts.length - 1] === 'localhost') {
  generic_hostname = 'localhost'
}
else if (hostname_parts.length > 2) {
  generic_hostname = hostname_parts.slice(-2).join('.')
}
const domain = generic_hostname ? `${location.hostname},${generic_hostname}` : location.hostname

init({
  domain,
  endpoint: `${location.origin}/api/event`,
  captureOnLocalhost: true,
  autoCapturePageviews: false,
})

function useTracker() {
  const { hasRole } = useCurUser()
  const curRequest = useRequest()
  const config = useConfig()
  const isEnabled = config.ENABLE_PLAUSIBLE
  const trackPageview = (options = {}) => {
    if (!isEnabled)
      return
    track('pageview', {
      ...options,
      props: {
        request_ref: curRequest.getRequestRef?.value,
        owner: String(curRequest.data?.owner.is_self ?? false),
        has_submitter_role: String(hasRole('submitter')),
        borrower: String(!!curRequest.data?.borrower?.is_self),
        has_borrower_role: String(hasRole('borrower')),
        valuer: String(curRequest.data?.valuer?.is_self ?? false),
        has_valuer_role: String(hasRole('valuer')),
        module: curRequest.data?.valuation_type ?? '',
      },
    })
  }
  const trackEvent = (eventName = '', options = {}) => {
    if (!isEnabled)
      return
    track(eventName, {
      ...options,
      props: {
        request_ref: curRequest.getRequestRef?.value,
        owner: String(curRequest.data?.owner?.is_self ?? false),
        has_submitter_role: String(hasRole('submitter')),
        borrower: String(curRequest.data?.borrower?.is_self ?? false),
        has_borrower_role: String(hasRole('borrower')),
        valuer: String(curRequest.data?.valuer?.is_self ?? false),
        has_valuer_role: String(hasRole('valuer')),
        module: curRequest.data?.valuation_type ?? '',
      },
    })
  }
  return { trackPageview, trackEvent }
}

export default useTracker
